<div class="populatiry-back" attr.aria-label="Popularity: {{popularity}}%" tabindex="0">
  <div class="populatiry-value" [style.width.%]="popularity">
  </div>
</div>
